import React from "react";
import { PricingType } from "../../../models/features/Integration/DmsSetup";
import { Box, Typography, Tooltip, IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

interface PriceNameProps {
  price: PricingType;
}
const GetPriceNames: React.FunctionComponent<PriceNameProps> = ({ price }) => {
  const renderPriceNameWithTooltip = (
    priceName: string,
    tooltipText: string
  ) => {
    return (
      <Box>
        <Typography fontSize="0.9rem">
          {priceName}
          <Tooltip title={tooltipText}>
            <IconButton>
              <InfoIcon sx={{ fontSize: "1rem" }} />
            </IconButton>
          </Tooltip>
        </Typography>
      </Box>
    );
  };

  switch (price) {
    case PricingType.Price:
      return renderPriceNameWithTooltip("Price", "This is mfr list price.");
    case PricingType.RetailPrice:
      return renderPriceNameWithTooltip(
        "Suggested Retail Price",
        "This is the suggested retail price."
      );
    case PricingType.UnitPrice:
      return renderPriceNameWithTooltip(
        "Unit Price",
        "This is the price per unit."
      );
    case PricingType.UnitListPriceLargest:
      return renderPriceNameWithTooltip(
        "Unit List Price Largest",
        "This is largest unit list price of a sold unit."
      );
    case PricingType.UnitListPriceLargestStock:
      return renderPriceNameWithTooltip(
        "Unit List Price Largest",
        "This is largest unit list of a serialized model number in your stock."
      );
    case PricingType.UnitListPriceSmallest:
      return renderPriceNameWithTooltip(
        "Unit List Price Smallest",
        "This is smallest unit list price of a sold unit."
      );
    case PricingType.UnitListPriceSmallestStock:
      return renderPriceNameWithTooltip(
        "Unit List Price Smallest",
        "This is smallest unit list of a serialized model number in your stock."
      );
    case PricingType.UnitListPriceLatest:
      return renderPriceNameWithTooltip(
        "Unit List Price Latest",
        "This is unit list price of a model that is latest in your sold units with largest stock number."
      );
    case PricingType.UnitListPriceLatestStock:
      return renderPriceNameWithTooltip(
        "Unit List Price Latest",
        "This is unit list price of a model that is latest in your stock with largest stock number."
      );
    case PricingType.MSRPListPriceLargest:
      return renderPriceNameWithTooltip(
        "MSRP List Price Largest",
        "This is largest MSRP of a sold unit."
      );
    case PricingType.MSRPListPriceLargestStock:
      return renderPriceNameWithTooltip(
        "MSRP List Price Largest",
        "This is largest MSRP of a serialized model number in your stock."
      );
    case PricingType.MSRPListPriceSmallest:
      return renderPriceNameWithTooltip(
        "MSRP List Price Smallest",
        "This is the smallest MSRP list price of a sold unit."
      );
    case PricingType.MSRPListPriceSmallestStock:
      return renderPriceNameWithTooltip(
        "MSRP List Price Smallest",
        "This is smallest MSRP of a serialized model number in your stock."
      );
    case PricingType.MSRPListPriceLatest:
      return renderPriceNameWithTooltip(
        "MSRP List Price Latest",
        "This is MSRP of a model that is latest in your sold units with largest stock number."
      );
    case PricingType.MSRPListPriceLatestStock:
      return renderPriceNameWithTooltip(
        "MSRP List Price Latest",
        "This is MSRP of a model that is latest in your stock with largest stock number."
      );
    default:
      return renderPriceNameWithTooltip("Price", "List Price.");
  }
};

export default GetPriceNames;
